import React from "react"

const projectsDescription = (
  <>
    Here are some of our group's Open Source projects. Admittedly, it is not a
    huge number yet – we are still at the beginning of our journey to Open
    Source. We are, however, already pretty active in OS upstream contributions
    (which is why we have listed a project fork here as well), and we are
    collaborating in foundations, e.g. in our co-founded{" "}
    <a
      href="https://projects.eclipse.org/projects/automotive.tractusx" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      Tractus-X
    </a>{" "}
    project within the Eclipse Foundation. We will publish more and more
    projects here, so please check back. Let’s code together!
  </>
)
export default projectsDescription
